export default __webpack_public_path__ + "static/media/alert-red.88f98533.svg";